/**
 * Mockup JS soubor pro date inputy. Nereaguje na změny v DOM, při implementaci ve Vue.js by toto mělo být přímo
 * součástí Vue komponenty.
 */
const datepickers = document.querySelectorAll('.js-date')
datepickers.forEach((datepicker) => {
	const input = datepicker.querySelector<HTMLInputElement>('.js-date__input')
	const icon = datepicker.querySelector('.js-date__icon')

	icon?.addEventListener('click', () => {
		try {
			input?.showPicker()
		} catch (e) {
			// noop
		}
	})
})
